import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["modal", "title", "notes", "form"]

  openModal(event) {
    const button = event.currentTarget
    this.currentOrganizationId = button.dataset.organizationId
    this.titleTarget.textContent = button.dataset.organizationTitle
    this.notesTarget.value = button.dataset.organizationNotes || ""
    this.modalTarget.classList.remove("hidden")
  }

  closeModal() {
    this.modalTarget.classList.add("hidden")
    this.currentOrganizationId = null
  }

  async save(event) {
    event.preventDefault()

    const notes = this.notesTarget.value
    const csrfToken = document.querySelector('meta[name="csrf-token"]').content

    try {
      const response = await fetch(`/admin/organizations/${this.currentOrganizationId}/update_notes`, {
        method: "PATCH",
        headers: {
          "Content-Type": "application/json",
          "X-CSRF-Token": csrfToken
        },
        body: JSON.stringify({ notes: notes })
      })

      if (response.ok) {
        window.location.reload()
      } else {
        alert("Failed to save notes")
      }
    } catch (error) {
      console.error("Error saving notes:", error)
      alert("Failed to save notes")
    }
  }
}
